import React from "react";
import { ReactComponent as AddExpertSelection } from "../../../assets/svg/profile-star.svg";

const AddExpertSelectCard = () => {
  return (
    <div className="flex flex-col w-[320px] h-[510px] items-center justify-center p-4 gap-4 rounded-[16px] border border-dashed border-muted bg-surface-2">
        {/* profile-star.svg hardcodes stroke="#727272" (the LIGHT value of
            --text-2) on each path, so it can't inherit. Targeting the paths
            re-points it at the token: byte-identical in light, legible in dark. */}
        <div className="flex flex-col gap-[16px] items-center justify-center [&_path]:stroke-text-2">
        <AddExpertSelection />
        <span className="text-[14px] font-[450] leading-none text-text-2 font-circular">Select at least 4 experts</span>
        </div>
    </div>
  );
};

export default AddExpertSelectCard;
